var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSection3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 150,
    viewBox: "0 0 320 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7230",
    "data-name": "Groupe 7230",
    transform: "translate(-150 -128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_735",
    "data-name": "Rectangle 735",
    transform: "translate(150 128)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 150,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 319.7,
    height: 149.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Titre_du_bloc",
    "data-name": "Titre du bloc",
    transform: "translate(211 152)",
    fill: "#717171",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -33.337,
    y: 0
  }, "Titre du bloc")), /*#__PURE__*/React.createElement("text", {
    id: "Sed_ut_perspiciatis_unde_omnis_iste_natus_error_sit_voluptatem_accusantium_doloremque_laudantium_totam_rem.",
    "data-name": "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem.",
    transform: "translate(173 168)",
    fill: "#717171",
    fontSize: 10,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "Sed ut perspiciatis unde omnis "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 23
  }, "iste natus error sit voluptatem "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 35
  }, "accusantium doloremque "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 47
  }, "laudantium, totam rem.")), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7228",
    "data-name": "Groupe 7228",
    transform: "translate(173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_736",
    "data-name": "Rectangle 736",
    transform: "translate(204 243)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 20,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 69.5,
    height: 19.5,
    rx: 4.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "En_savoir_plus",
    "data-name": "En savoir plus",
    transform: "translate(239 256)",
    fill: "#717171",
    fontSize: 8,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.111,
    y: 0
  }, "En savoir plus"))), /*#__PURE__*/React.createElement("text", {
    id: "Sed_ut_perspiciatis_unde_omnis_iste_natus_error_sit_voluptatem_accusantium_doloremque_laudantium_totam_rem.-2",
    "data-name": "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem.",
    transform: "translate(319 168)",
    fill: "#717171",
    fontSize: 10,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "Sed ut perspiciatis unde omnis "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 23
  }, "iste natus error sit voluptatem "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 35
  }, "accusantium doloremque "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 47
  }, "laudantium, totam rem.")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection3);
export default __webpack_public_path__ + "static/media/section3.3f122e85d843ecfde9c22102842220d7.svg";
export { ForwardRef as ReactComponent };